import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";

const DETMOLD_LOGO = "/assets/logo-detmold.png";

export default function AdminLogin() {
  const { user, login, ready } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("Detmold");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (ready && user) return <Navigate to="/admin" replace />;

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) { toast.success("Willkommen zurück"); nav("/admin"); }
    else toast.error(r.error);
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 p-6" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white border border-brand-line p-10">
        <Link to="/" className="flex items-center gap-3 mb-10" data-testid="admin-login-logo">
          <img src={DETMOLD_LOGO} alt="Detmold" className="h-10 w-auto" />
          <span className="text-xs leading-tight text-neutral-500 border-l border-brand-line pl-3">
            Kulturstadt<br />im Teutoburger Wald
          </span>
        </Link>
        <h1 className="font-semibold text-3xl mb-2">Admin-Anmeldung</h1>
        <p className="text-sm text-neutral-500 mb-8">Quartier am Hornschen Tor · Verwaltung</p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-xs text-neutral-500 mb-1.5">Benutzer</label>
            <input
              type="text"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              className="w-full border border-brand-line px-4 py-3 text-sm focus:outline-none focus:border-[hsl(var(--brand-green-strong))] focus:ring-1 focus:ring-[hsl(var(--brand-green-strong))]"
            />
          </div>
          <div>
            <label className="block text-xs text-neutral-500 mb-1.5">Passwort</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              className="w-full border border-brand-line px-4 py-3 text-sm focus:outline-none focus:border-[hsl(var(--brand-green-strong))] focus:ring-1 focus:ring-[hsl(var(--brand-green-strong))]"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-[hsl(var(--brand-green-dark))] text-white py-3 hover:bg-[hsl(var(--brand-green-strong))] transition-colors text-sm disabled:opacity-50"
          >
            {loading ? "Anmelden…" : "Anmelden"}
          </button>
        </form>
      </div>
    </div>
  );
}
